import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-40aee67c")

_pushScopeId("data-v-40aee67c")
const _hoisted_1 = { class: "ui__defectList_main" }
const _hoisted_2 = { class: "ui__defectList_title_left" }
const _hoisted_3 = { class: "ui__defectList_title_right" }
const _hoisted_4 = {
  key: 0,
  class: "ui__defectList_title_normal"
}
const _hoisted_5 = {
  key: 1,
  class: "ui__defectList_title_abnormal"
}
const _hoisted_6 = { class: "ui__defectList_title_icon" }
const _hoisted_7 = { class: "ui__defectList_list" }
const _hoisted_8 = { class: "ui__defectList_list_item_flex" }
const _hoisted_9 = { class: "ui__defectList_list_item_left" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "ui__defectList_list_item_center" }, null, -1)
const _hoisted_11 = { class: "ui__defectList_list_item_right" }
const _hoisted_12 = {
  key: 0,
  class: "text-success"
}
const _hoisted_13 = {
  key: 1,
  class: "text-error"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "ui__defectList_title",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeIsShowAllState(_ctx.state.listName)))
    }, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.state.listName), 1),
      _createVNode("div", _hoisted_3, [
        (_ctx.state.listNormalNumber > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("img", {
                class: "ui__defectList_title_defect_icon",
                src: require('@/assets/image/checkSuccess-icon.png')
              }, null, 8, ["src"]),
              _createTextVNode(" " + _toDisplayString(_ctx.state.listNormalNumber) + "项 ", 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.listDefectNumber > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("img", {
                class: "ui__defectList_title_defect_icon",
                src: require('@/assets/image/checkError-icon.png')
              }, null, 8, ["src"]),
              _createTextVNode(" " + _toDisplayString(_ctx.state.listDefectNumber) + "项 ", 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_6, [
          _createVNode("img", {
            src: require('@/assets/image/icon-bottom.png'),
            class: {'ui__isShowAll':_ctx.state.isShowAll}
          }, null, 10, ["src"])
        ])
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_7, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.defectList, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: "ui__defectList_list_item",
          key: item.checkItemCode
        }, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, _toDisplayString(item.checkItemName), 1),
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              (item.itemDesc === '正常' || item.itemDesc === '无此部件' || item.itemDesc === '受限不可检' ||
                        item.itemDesc === '无事故痕迹'|| item.itemDesc === '无火烧痕迹'|| item.itemDesc === '无泡水痕迹')
                ? (_openBlock(), _createBlock("span", _hoisted_12, "正常"))
                : (_openBlock(), _createBlock("span", _hoisted_13, "异常"))
            ])
          ])
        ]))
      }), 128))
    ], 512), [
      [_vShow, _ctx.state.isShowAll]
    ])
  ]))
})